import { createApimApiClient } from "../createApimClient";

export const infoServiceClient = createApimApiClient(
	process.env.GATSBY_INFOSERVICE_API,
	process.env.GATSBY_INFOSERVICE_APIM_SUB_KEY
);
